import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from 'angularfire2/firestore';
import { uccUsers } from './uccPerms.model';
import { Observable } from 'rxjs'

@Injectable()
export class UccPermsService {
    public pushID: any;
    vehMaintDocCol: AngularFirestoreCollection<uccUsers>;
    vehMaintDoc: AngularFirestoreDocument<uccUsers>;
    vehStatusCol: AngularFirestoreCollection<uccUsers>;
    vehStatusDoc: AngularFirestoreDocument<uccUsers>;
    vehiclesMaint: Observable<uccUsers[]>

    maintItems: Observable<uccUsers[]>;

    maintItemsStatus: Observable<uccUsers[]>;

    constructor(public afs: AngularFirestore) {
        this.vehMaintDocCol = this.afs.collection('Maintenance');
        this.vehStatusCol = this.afs.collection('VeicleStatus')

        // this.vehiclesMaint = this.vehMaintDocCol.snapshotChanges().map(changes => {
        //     return changes.map(a => {
        //         const data = a.payload.doc.data() as MaintVehicle;
        //         data.id = a.payload.doc.id;
        //         return data;
        //     })UccUsersService
        // });data
        this.maintItems = this.afs.collection('Maintenance').valueChanges();
    }
    addUccPermsHistoryDoc(data) {
        var doc_id = this.afs.createId();
        this.vehMaintDoc = this.afs.collection("ucc_permissions_history")
                            .doc(data.mob)
                            .collection(data.date)
                            .doc(doc_id);
                            this.vehMaintDoc.set(data.data)
    }

    addVehStatusDoc(status, date) {
        status.push_id = this.afs.createId();
        this.vehStatusDoc = this.afs.collection('VeicleStatus').doc(status.vehId).collection(date).doc(status.push_id);
        this.vehStatusDoc.set(status)
        // console.log(status.push_id)
        // console.log(status)
    }

    getDocStatus(obj) {
        this.maintItems = this.afs.collection('Maintenance', ref => ref
            // .where('statusDate', '==', obj.statusDate)
            .where('Status', '==', obj.Status)
            .where('stage', '==', obj.stage)
            .where('tab_position', '==', obj.tab_position)
            .where('request_status', '==', obj.request_status)
            .where('prjid', '==', obj.prjid).where('vehId', '==', obj.vehId))
            .valueChanges();
        // console.log("para", obj)
        return this.maintItems
    };
}


// WEBPACK FOOTER //
// ./src/app/superAdmin/users/UccPerms.service.ts